export const environment = {
  production: false,
  baseUrl: 'https://homologacao.vivest.com.br',
  apiUrl:'apis/api-instituto-online',
  chaveFornecedor: '7788f344-4e9b-4938-b11f-7f847c9d230c',
  ocpapimsubscriptionkey:'3bd934c93dbc4503b20442ac87489098',
  ocpapimsubscriptionkeyPortal: '403609255a594561b4bb6a3eb54e1e41',
  ocpapimsubscriptionkeyPrevidencia: '3bd934c93dbc4503b20442ac87489098',
  ocpapimsubscriptionkeyBaseUnificada: 'e44933499e5f492093fb97e35b30bea9',
  requerimentoBaseUrl: 'apis/api-requerimento-beneficio-dev',
  ocpapimsubscriptionkeyRequerimento: '3f4a74ed542944caa2fe7091d1b29ba6',
  parametrizacaoBaseUrl: 'apis/api-parametrizacao-previdencia-dev',
  ocpapimsubscriptionkeyParametrizacao: '80a7cb9c745a40c080acc06e4cedc9b3',
  requerimentoTipoInstitutoId: 22 as number | null,
  idBeneficioAposentadoria: 1,
  secretPortal: '79f52b2cc565ef16f07d7f8f52df4ecdd7fa1923995f16333fc4b2055476a146',
  baseUnificadaParametrosUrl: 'apis/api-baseunificada-cadastro-parametro',
  ocpapimsubscriptionkeybaseUnificadaParametros: '1182dd96a37f4e6e8ad98c2b6e1806b9',
  x_api_key: 'edcff23d-e71b-4480-b0f9-5b62bb53497d',
};
